<template>
  <div class="linkGroup">
    <div class="linkGroup--title">
      <h6 class="titleTiny">
        Acesse o documento no idioma desejado:
      </h6>
    </div>
    <ul class="linkGroup--links">
      <li class="linkGroup--linksItem">
        <LinkImg
        :link='linkPT'
        title='Download da publicação em português'
        :img='flagPT'
        alt='Download da publicação em português'/>
      </li>
      <li class="linkGroup--linksItem">
        <LinkImg
        :link='linkES'
        title='Download da publicação em espanhol'
        :img='flagES'
        alt='Download da publicação em espanhol'/>
      </li>
      <li class="linkGroup--linksItem">
        <LinkImg
        :link='linkIN'
        title='Download da publicação em inglês'
        :img='flagIN'
        alt='Download da publicação em inglês'/>
      </li>
    </ul>
  </div>
</template>

<script>
import LinkImg from '@/components/_LinkImg'

export default {
  name: 'LinksGroup',
  data () {
    return {
      flagPT: require('../assets/images/linkPT.svg'),
      flagES: require('../assets/images/linkES.svg'),
      flagIN: require('../assets/images/linkIN.svg')
    }
  },
  components: {
    LinkImg
  },
  props: {
    linkPT: {
      default: '#linkpt'
    },
    linkES: {
      default: '#linkES'
    },
    linkIN: {
      default: '#linkIN'
    }
  }
}
</script>

<style>

</style>
